const speciesRouter = [
    {
        path:'',
        name:'species-index',
        component: () => import(/* webpackChunkName: "about" */ '../views/species/index.vue'),
        children:[
            {
                path:'',
                name:'species-empty',
                component: () => import(/* webpackChunkName: "about" */ '../components/empty.vue'),
                props: { message: '請點選左側列表檢視物種分類 或 點選新增物種分類' }
            },
            {
                path:'create',
                name:'species-create',
                component: () => import(/* webpackChunkName: "about" */ '../views/species/speciesCreate.vue')
            },
            {
                path:'detail/:id',
                name:'species-detail',
                component: () => import(/* webpackChunkName: "about" */ '../views/species/speciesDetail.vue'),
                children:[
                    {
                        path:'',
                        name:'species-detail-empty',
                        component: () => import(/* webpackChunkName: "about" */ '../components/empty.vue'),
                        props: { message: '請點選左側列表檢視物種 或 點選新增物種' }
                    },
                    {
                        path:'create',
                        name:'specie-create',
                        component: () => import(/* webpackChunkName: "about" */ '../views/species/specie/specieCreate.vue'),
                    },
                    {
                        path:'detail/:sid',
                        name:'specie-detail',
                        component: () => import(/* webpackChunkName: "about" */ '../views/species/specie/specieDetail.vue'),
                    },
                    {
                        path:'edit/:sid',
                        name:'specie-edit',
                        component: () => import(/* webpackChunkName: "about" */ '../views/species/specie/specieEdit.vue'),
                    }
                ]
            },
            {
                path:'edit/:id',
                name:'species-edit',
                component: () => import(/* webpackChunkName: "about" */ '../views/species/speciesEdit.vue')
            },
        ]
    },
    
  ]
  export default speciesRouter